import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from './../../../shared/shared.module';
import { EditPartnerRoutingModule } from './edit-partner.-routing.module';
import { EditPartnerComponent } from './edit-partner.component';
import { TabDadosParceiroComponent } from '../components/tab-dados-parceiro/tab-dados-parceiro.component';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, SharedModule, EditPartnerRoutingModule, MatIconModule, MatMenuModule],
  declarations: [
    EditPartnerComponent,
    TabDadosParceiroComponent
  ]
})
export class EditPartnerModule {}
